<div>
  <div class="flex justify-between relative flex-col">
    <div class="bg-primary flex items-center justify-between">
      <mat-tab-group
        (selectedIndexChange)="onTabRouteChange($event)"
        [selectedIndex]="currentRouteTab"
        class="home-tabs"
      >
        <mat-tab *ngIf="!isOrdersManager()" label="MY QUOTES"></mat-tab>
        <mat-tab label="MY ORDERS"></mat-tab>
      </mat-tab-group>
    </div>
  </div>

  <div class="filters-container flex gap-4 py-4 items-center">
    <mat-form-field *ngIf="currentRouteTab === 0" class="flex-1">
      <mat-label>Filter by Client</mat-label>
      <input
        type="text"
        matInput
        [formControl]="clientFilterControl"
        [matAutocomplete]="auto"
        (click)="clientFilterControl.setValue(clientFilterControl.value)"
      />
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
        @for (customer of filteredOptions$ | async; let i = $index; track i) {
          <mat-option [value]="customer">
            {{ customer.firstName }} {{ customer.lastName }}, #{{ customer.customerCode }},
            {{ customer.company }},
            {{ customer.customerState }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field class="flex-1">
      <mat-label>Filter by Status</mat-label>
      <mat-select [formControl]="statusFilterControl">
        @for (option of statuses(); let i = $index; track i) {
          <mat-option [value]="option.key">{{ option.value }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <button mat-flat-button color="primary" (click)="clearFilters()">Clear Filters</button>
  </div>

  <router-outlet></router-outlet>

  <div class="flex justify-between relative flex-col">
    <mat-tab-group
      class="orders-status-tabs"
      [selectedIndex]="selectedOrdersTab"
      (selectedIndexChange)="onOrdersTabChange($event)"
    >
      <mat-tab label="PAST DUE ORDERS" class="bg-primary">
        <div class="bg-white">
          @if (pastDueOrdersLoading()) {
            <div class="flex justify-center p-4">
              <mat-spinner></mat-spinner>
            </div>
          } @else if (pastDueOrdersError()) {
            <div class="flex justify-center p-4">
              <p class="text-red-500">{{ errorText }}</p>
            </div>
          } @else {
            <table
              mat-table
              [dataSource]="dataSource"
              [matSortActive]="currentSort.active"
              [matSortDirection]="currentSort.direction"
              matSort
              (matSortChange)="sortData($event)"
            >
              <ng-container matColumnDef="orderId">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  class="border-b p-4 text-left"
                >
                  Job #
                </th>
                <td mat-cell *matCellDef="let element" class="border-b p-4">
                  {{ element.orderId }}
                </td>
              </ng-container>

              <ng-container matColumnDef="description">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  class="border-b p-4 text-left"
                >
                  Description
                </th>
                <td mat-cell *matCellDef="let element" class="border-b p-4">
                  {{ element.description }}
                </td>
              </ng-container>

              <ng-container matColumnDef="clientPurchaseOrder">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  class="border-b p-4 text-left"
                >
                  Client PO #
                </th>
                <td mat-cell *matCellDef="let element" class="border-b p-4">
                  {{ element.clientPurchaseOrder }}
                </td>
              </ng-container>

              <ng-container matColumnDef="caNumber">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  class="border-b p-4 text-left"
                >
                  CA #
                </th>
                <td mat-cell *matCellDef="let element" class="border-b p-4">
                  {{ element.caNumber.caNumber }}
                </td>
              </ng-container>

              <ng-container matColumnDef="promisedDate">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  class="border-b p-4 text-left"
                >
                  Due Date
                </th>
                <td mat-cell *matCellDef="let element" class="border-b p-4">
                  {{ element.dueDate | date: CONFIG.date.dueDateFormat }}
                </td>
              </ng-container>

              <ng-container matColumnDef="dateCreated">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  class="border-b p-4 text-left"
                >
                  Date Created
                </th>
                <td mat-cell *matCellDef="let element" class="border-b p-4">
                  {{ element.dateCreated | date: CONFIG.date.createdDateFormat }}
                </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  class="border-b p-4 text-left"
                >
                  Status
                </th>
                <td mat-cell *matCellDef="let element" class="border-b p-4">
                  {{ element.status }}
                </td>
              </ng-container>

              <ng-container matColumnDef="client">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  class="border-b p-4 text-left"
                >
                  Client
                </th>
                <td mat-cell *matCellDef="let element" class="border-b p-4">
                  {{ element.client }}
                </td>
              </ng-container>

              <ng-container matColumnDef="assignee">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  class="border-b p-4 text-left"
                >
                  Assignee
                </th>
                <td mat-cell *matCellDef="let element" class="border-b p-4">
                  {{ element.assignee }}
                </td>
              </ng-container>

              <ng-container matColumnDef="totalQuantity">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  class="border-b p-4 text-left"
                >
                  Quantity
                </th>
                <td mat-cell *matCellDef="let element" class="border-b p-4">
                  {{ element.quantity }}
                </td>
              </ng-container>

              <ng-container matColumnDef="orderTotalPrice">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  class="border-b p-4 text-left"
                >
                  Total Price
                </th>
                <td mat-cell *matCellDef="let element" class="border-b p-4">
                  {{ element.totalPrice | currency: 'USD' : 'symbol' : '1.0-2' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="dateUpdated">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  class="border-b p-4 text-left"
                >
                  Last Edited
                </th>
                <td mat-cell *matCellDef="let element" class="border-b p-4">
                  {{ element.lastEdited | date: CONFIG.date.createdDateFormat }}
                </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="border-b p-4 text-right w-24"></th>
                <td mat-cell *matCellDef="let element" class="border-b p-4 text-right">
                  <div class="invisible group-hover:visible flex items-center justify-end gap-2">
                    <button
                      mat-icon-button
                      matTooltip="Edit Order"
                      [routerLink]="['/orders', element.id, 'edit']"
                      (click)="$event.stopPropagation()"
                      class="text-gray-700"
                    >
                      <mat-icon>edit</mat-icon>
                    </button>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
                [routerLink]="['/orders', row.id, 'view']"
                class="hover:bg-gray-100 cursor-pointer quote-row group"
              ></tr>
            </table>
            <div
              *ngIf="
                !pastDueOrdersLoading() && !pastDueOrdersError() && dataSource.data.length === 0
              "
              class="text-center text-gray-500 py-8"
            >
              There are no records available.
            </div>
            <ciwc-pagination
              [currentPage]="pageIndexPastDueOrders"
              [pageSize]="pageSizePastDueOrders"
              [totalItems]="totalOrders"
              [pageSizeOptions]="pageSizeOptions"
              (pageChange)="handlePageEvent($event)"
            ></ciwc-pagination>

            <!-- Hidden paginator for functionality -->
            <div class="hidden">
              <mat-paginator
                #paginator
                [length]="totalOrders"
                [pageSize]="pageSizePastDueOrders"
                [pageSizeOptions]="pageSizeOptions"
                (page)="handlePageEvent($event)"
                aria-label="Select page"
              >
              </mat-paginator>
            </div>

            <div *ciwcRoleAccess="['ROLE_SUPER_ADMIN']" class="flex justify-end">
              <p *ngIf="pastDueOrdersTotalPrice()" class="text-lg">
                Past Due Orders Total Price :
                {{ pastDueOrdersTotalPrice() | currency: 'USD' : 'symbol' : '1.0-2' }}
              </p>
            </div>
          }
        </div>
      </mat-tab>
      <mat-tab label="ORDERS DUE TODAY">
        <div class="bg-white w-full">
          @if (ordersDueTodayLoading()) {
            <div class="flex justify-center p-4">
              <mat-spinner></mat-spinner>
            </div>
          } @else if (ordersDueTodayError()) {
            <div class="flex justify-center p-4">
              <p class="text-red-500">{{ errorText }}</p>
            </div>
          } @else {
            <table
              mat-table
              [matSortActive]="currentSort.active"
              [matSortDirection]="currentSort.direction"
              [dataSource]="dataSource"
              matSort
              (matSortChange)="sortData($event)"
            >
              <ng-container matColumnDef="orderId">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  class="border-b p-4 text-left"
                >
                  Job #
                </th>
                <td mat-cell *matCellDef="let element" class="border-b p-4">
                  {{ element.orderId }}
                </td>
              </ng-container>

              <ng-container matColumnDef="description">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  class="border-b p-4 text-left"
                >
                  Description
                </th>
                <td mat-cell *matCellDef="let element" class="border-b p-4">
                  {{ element.description }}
                </td>
              </ng-container>

              <ng-container matColumnDef="clientPurchaseOrder">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  class="border-b p-4 text-left"
                >
                  Client PO #
                </th>
                <td mat-cell *matCellDef="let element" class="border-b p-4">
                  {{ element.clientPurchaseOrder }}
                </td>
              </ng-container>

              <ng-container matColumnDef="caNumber">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  class="border-b p-4 text-left"
                >
                  CA #
                </th>
                <td mat-cell *matCellDef="let element" class="border-b p-4">
                  {{ element.caNumber.caNumber }}
                </td>
              </ng-container>

              <ng-container matColumnDef="promisedDate">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  class="border-b p-4 text-left"
                >
                  Due Date
                </th>
                <td mat-cell *matCellDef="let element" class="border-b p-4">
                  {{ element.dueDate }}
                </td>
              </ng-container>

              <ng-container matColumnDef="dateCreated">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  class="border-b p-4 text-left"
                >
                  Date Created
                </th>
                <td mat-cell *matCellDef="let element" class="border-b p-4">
                  {{ element.dateCreated }}
                </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  class="border-b p-4 text-left"
                >
                  Status
                </th>
                <td mat-cell *matCellDef="let element" class="border-b p-4">
                  {{ element.status }}
                </td>
              </ng-container>

              <ng-container matColumnDef="client">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  class="border-b p-4 text-left"
                >
                  Client
                </th>
                <td mat-cell *matCellDef="let element" class="border-b p-4">
                  {{ element.client }}
                </td>
              </ng-container>

              <ng-container matColumnDef="assignee">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  class="border-b p-4 text-left"
                >
                  Assignee
                </th>
                <td mat-cell *matCellDef="let element" class="border-b p-4">
                  {{ element.assignee }}
                </td>
              </ng-container>

              <ng-container matColumnDef="totalQuantity">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  class="border-b p-4 text-left"
                >
                  Quantity
                </th>
                <td mat-cell *matCellDef="let element" class="border-b p-4">
                  {{ element.quantity }}
                </td>
              </ng-container>

              <ng-container matColumnDef="orderTotalPrice">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  class="border-b p-4 text-left"
                >
                  Total Price
                </th>
                <td mat-cell *matCellDef="let element" class="border-b p-4">
                  {{ element.totalPrice | currency: 'USD' : 'symbol' : '1.0-2' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="dateUpdated">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  class="border-b p-4 text-left"
                >
                  Last Edited
                </th>
                <td mat-cell *matCellDef="let element" class="border-b p-4">
                  {{ element.lastEdited | date: CONFIG.date.createdDateFormat }}
                </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="border-b p-4 text-right w-24"></th>
                <td mat-cell *matCellDef="let element" class="border-b p-4 text-right">
                  <div class="invisible group-hover:visible flex items-center justify-end gap-2">
                    <button
                      mat-icon-button
                      matTooltip="Edit Order"
                      [routerLink]="['/orders', element.id, 'edit']"
                      (click)="$event.stopPropagation()"
                      class="text-gray-700"
                    >
                      <mat-icon>edit</mat-icon>
                    </button>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
                [routerLink]="['/orders', row.id, 'view']"
                class="hover:bg-gray-100 cursor-pointer quote-row group"
              ></tr>
            </table>
            <div
              *ngIf="
                !ordersDueTodayLoading() && !ordersDueTodayError() && dataSource.data.length === 0
              "
              class="text-center text-gray-500 py-8"
            >
              There are no records available.
            </div>
            <ciwc-pagination
              [currentPage]="pageIndexOrdersDueToday"
              [pageSize]="pageSizeOrdersDueToday"
              [totalItems]="totalOrders"
              [pageSizeOptions]="pageSizeOptions"
              (pageChange)="handlePageEvent($event)"
            ></ciwc-pagination>

            <!-- Hidden paginator for functionality -->
            <div class="hidden">
              <mat-paginator
                #paginator
                [length]="totalOrders"
                [pageSize]="pageSizeOrdersDueToday"
                [pageSizeOptions]="pageSizeOptions"
                (page)="handlePageEvent($event)"
                aria-label="Select page"
              >
              </mat-paginator>
            </div>

            <div *ciwcRoleAccess="['ROLE_SUPER_ADMIN']" class="flex justify-end">
              <p *ngIf="ordersDueTodayTotalPrice()" class="text-lg">
                Orders Due Today Total Price :
                {{ ordersDueTodayTotalPrice() | currency: 'USD' : 'symbol' : '1.0-2' }}
              </p>
            </div>
          }
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
